import React from 'react';
import { useMessages } from '../../context/MessagesContext';
import Toast from './Toast';
import './ToastContainer.scss';

const ToastContainer: React.FC = () => {
    const { messages, removeMessage } = useMessages();

    if (messages.length === 0) return null;

    return (
        <div className="toast-container">
            {messages.map((message) => (
                <Toast key={message.id} message={message} onClose={removeMessage} />
            ))}
        </div>
    );
};

export default ToastContainer;

